import { compareTo3ankvs086tmwq as compareTo } from '../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { rangeUntilvkeu8z37zujo as rangeUntil } from '../../../kotlin-kotlin-stdlib/kotlin/ranges/Ranges.mjs';
import { InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DoubleSerializer_getInstance3da4hv5ndgjlx as DoubleSerializer_getInstance } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _Length___init__impl__mrryhn(meters) {
  return meters;
}
function _Length___get_meters__impl__co03t8($this) {
  return $this;
}
function Length__compareTo_impl_4hbpn1($this, other) {
  return compareTo(_Length___get_meters__impl__co03t8($this), _Length___get_meters__impl__co03t8(other));
}
function Length__compareTo_impl_4hbpn1_0($this, other) {
  return Length__compareTo_impl_4hbpn1($this.l4w_1, other instanceof Length() ? other.l4w_1 : THROW_CCE());
}
function _Length___get_centimeters__impl__ltzset($this) {
  return _Length___get_meters__impl__co03t8($this) / 0.01;
}
function _Length___get_kilometers__impl__syiikt($this) {
  return _Length___get_meters__impl__co03t8($this) / 1000.0;
}
function _Length___get_lightYears__impl__sob8wy($this) {
  return _Length___get_meters__impl__co03t8($this) / 9.4607304725808E15;
}
function _Length___get_micrometer__impl__xab82h($this) {
  return _Length___get_meters__impl__co03t8($this) / 1.0E-6;
}
function _Length___get_millimeter__impl__i75bku($this) {
  return _Length___get_meters__impl__co03t8($this) / 0.001;
}
function _Length___get_nanometer__impl__86nsy3($this) {
  return _Length___get_meters__impl__co03t8($this) / 1.0E-9;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      a3m(_this__u8e3s4) {
        return _Length___init__impl__mrryhn(_this__u8e3s4 * 1609.344);
      }
      m2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function Length__toString_impl_qoaji3($this) {
  return Length__toStringMetric_impl_bnt6hh($this);
}
function Length__toStringMetric_impl_bnt6hh($this) {
  var tmp0_subject = _Length___get_meters__impl__co03t8($this);
  return rangeUntil(0.0, 1.0E-7).l2(tmp0_subject) ? '' + _Length___get_nanometer__impl__86nsy3($this) + ' nm' : rangeUntil(1.0E-7, 1.0E-5).l2(tmp0_subject) ? '' + _Length___get_micrometer__impl__xab82h($this) + ' mm' : rangeUntil(1.0E-4, 0.01).l2(tmp0_subject) ? '' + _Length___get_millimeter__impl__i75bku($this) + ' mm' : rangeUntil(0.01, 1.0).l2(tmp0_subject) ? '' + _Length___get_centimeters__impl__ltzset($this) + ' cm' : rangeUntil(1.0, 1000.0).l2(tmp0_subject) ? '' + _Length___get_meters__impl__co03t8($this) + ' m' : rangeUntil(1000.0, 9.4607304725808E13).l2(tmp0_subject) ? '' + _Length___get_kilometers__impl__syiikt($this) + ' km' : '' + _Length___get_lightYears__impl__sob8wy($this) + ' ly';
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.Length', this);
        tmp0_serialDesc.c1b('meters', false);
        this.m4w_1 = tmp0_serialDesc;
      }
      n4w(encoder, value) {
        var tmp0_inlineEncoder = encoder.r14(this.m4w_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.n14(_Length___get_meters__impl__co03t8(value));
        }
      }
      oz(encoder, value) {
        return this.n4w(encoder, value instanceof Length() ? value.l4w_1 : THROW_CCE());
      }
      o4w(decoder) {
        return _Length___init__impl__mrryhn(decoder.j13(this.m4w_1).f13());
      }
      pz(decoder) {
        return new (Length())(this.o4w(decoder));
      }
      az() {
        return this.m4w_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function Length__hashCode_impl_4x4mp8($this) {
  return getNumberHashCode($this);
}
function Length__equals_impl_odc88o($this, other) {
  if (!(other instanceof Length()))
    return false;
  var tmp0_other_with_cast = other.l4w_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var LengthClass;
function Length() {
  if (LengthClass === VOID) {
    class $ {
      constructor(meters) {
        this.l4w_1 = meters;
      }
      p4w(other) {
        return Length__compareTo_impl_4hbpn1(this.l4w_1, other);
      }
      d(other) {
        return Length__compareTo_impl_4hbpn1_0(this, other);
      }
      toString() {
        return Length__toString_impl_qoaji3(this.l4w_1);
      }
      hashCode() {
        return Length__hashCode_impl_4x4mp8(this.l4w_1);
      }
      equals(other) {
        return Length__equals_impl_odc88o(this.l4w_1, other);
      }
    }
    initMetadataForClass($, 'Length', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance});
    LengthClass = $;
  }
  return LengthClass;
}
function _Temperature___init__impl__i36a2t(celsius) {
  return celsius;
}
function _Temperature___get_celsius__impl__lhbsrw($this) {
  return $this;
}
function Temperature__compareTo_impl_hlr075($this, other) {
  return compareTo(_Temperature___get_celsius__impl__lhbsrw($this), _Temperature___get_celsius__impl__lhbsrw(other));
}
function Temperature__compareTo_impl_hlr075_0($this, other) {
  return Temperature__compareTo_impl_hlr075($this.q4w_1, other instanceof Temperature() ? other.q4w_1 : THROW_CCE());
}
function _Temperature___get_fahrenheit__impl__xao1tu($this) {
  return _Temperature___get_celsius__impl__lhbsrw($this) * 9 / 5 + 32;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      r4w(_this__u8e3s4) {
        return _Temperature___init__impl__i36a2t(_this__u8e3s4 * 1.0);
      }
      s4w(_this__u8e3s4) {
        return _Temperature___init__impl__i36a2t((_this__u8e3s4 - 32.0) * 5 / 9);
      }
      m2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function Temperature__toString_impl_yh7zyr($this) {
  return '' + _Temperature___get_celsius__impl__lhbsrw($this) + '\xB0C';
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.Temperature', this);
        tmp0_serialDesc.c1b('celsius', false);
        this.t4w_1 = tmp0_serialDesc;
      }
      u4w(encoder, value) {
        var tmp0_inlineEncoder = encoder.r14(this.t4w_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.n14(_Temperature___get_celsius__impl__lhbsrw(value));
        }
      }
      oz(encoder, value) {
        return this.u4w(encoder, value instanceof Temperature() ? value.q4w_1 : THROW_CCE());
      }
      v4w(decoder) {
        return _Temperature___init__impl__i36a2t(decoder.j13(this.t4w_1).f13());
      }
      pz(decoder) {
        return new (Temperature())(this.v4w(decoder));
      }
      az() {
        return this.t4w_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
function Temperature__hashCode_impl_esq57i($this) {
  return getNumberHashCode($this);
}
function Temperature__equals_impl_91r1ru($this, other) {
  if (!(other instanceof Temperature()))
    return false;
  var tmp0_other_with_cast = other.q4w_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var TemperatureClass;
function Temperature() {
  if (TemperatureClass === VOID) {
    class $ {
      constructor(celsius) {
        this.q4w_1 = celsius;
      }
      w4w(other) {
        return Temperature__compareTo_impl_hlr075(this.q4w_1, other);
      }
      d(other) {
        return Temperature__compareTo_impl_hlr075_0(this, other);
      }
      toString() {
        return Temperature__toString_impl_yh7zyr(this.q4w_1);
      }
      hashCode() {
        return Temperature__hashCode_impl_esq57i(this.q4w_1);
      }
      equals(other) {
        return Temperature__equals_impl_91r1ru(this.q4w_1, other);
      }
    }
    initMetadataForClass($, 'Temperature', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_0});
    TemperatureClass = $;
  }
  return TemperatureClass;
}
function _Area___init__impl__ijsx70(squareMeters) {
  return squareMeters;
}
function _Area___get_squareMeters__impl__tdkp4u($this) {
  return $this;
}
function Area__compareTo_impl_udkzyy($this, other) {
  return compareTo(_Area___get_squareMeters__impl__tdkp4u($this), _Area___get_squareMeters__impl__tdkp4u(other));
}
function Area__compareTo_impl_udkzyy_0($this, other) {
  return Area__compareTo_impl_udkzyy($this.x4w_1, other instanceof Area() ? other.x4w_1 : THROW_CCE());
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function Area__toString_impl_owfsr0($this) {
  return '' + _Area___get_squareMeters__impl__tdkp4u($this) + ' m^2';
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.Area', this);
        tmp0_serialDesc.c1b('squareMeters', false);
        this.y4w_1 = tmp0_serialDesc;
      }
      z4w(encoder, value) {
        var tmp0_inlineEncoder = encoder.r14(this.y4w_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.n14(_Area___get_squareMeters__impl__tdkp4u(value));
        }
      }
      oz(encoder, value) {
        return this.z4w(encoder, value instanceof Area() ? value.x4w_1 : THROW_CCE());
      }
      a4x(decoder) {
        return _Area___init__impl__ijsx70(decoder.j13(this.y4w_1).f13());
      }
      pz(decoder) {
        return new (Area())(this.a4x(decoder));
      }
      az() {
        return this.y4w_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
function Area__hashCode_impl_odicf9($this) {
  return getNumberHashCode($this);
}
function Area__equals_impl_8gtmo1($this, other) {
  if (!(other instanceof Area()))
    return false;
  var tmp0_other_with_cast = other.x4w_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var AreaClass;
function Area() {
  if (AreaClass === VOID) {
    class $ {
      constructor(squareMeters) {
        this.x4w_1 = squareMeters;
      }
      b4x(other) {
        return Area__compareTo_impl_udkzyy(this.x4w_1, other);
      }
      d(other) {
        return Area__compareTo_impl_udkzyy_0(this, other);
      }
      toString() {
        return Area__toString_impl_owfsr0(this.x4w_1);
      }
      hashCode() {
        return Area__hashCode_impl_odicf9(this.x4w_1);
      }
      equals(other) {
        return Area__equals_impl_8gtmo1(this.x4w_1, other);
      }
    }
    initMetadataForClass($, 'Area', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_1});
    AreaClass = $;
  }
  return AreaClass;
}
function _Volume___init__impl__tjrqop(cubicMeters) {
  return cubicMeters;
}
function _Volume___get_cubicMeters__impl__6kaaeg($this) {
  return $this;
}
function Volume__compareTo_impl_e47i3d($this, other) {
  return compareTo(_Volume___get_cubicMeters__impl__6kaaeg($this), _Volume___get_cubicMeters__impl__6kaaeg(other));
}
function Volume__compareTo_impl_e47i3d_0($this, other) {
  return Volume__compareTo_impl_e47i3d($this.c4x_1, other instanceof Volume() ? other.c4x_1 : THROW_CCE());
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
function Volume__toString_impl_ewnyiv($this) {
  return '' + _Volume___get_cubicMeters__impl__6kaaeg($this) + ' m\xB3';
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.Volume', this);
        tmp0_serialDesc.c1b('cubicMeters', false);
        this.d4x_1 = tmp0_serialDesc;
      }
      e4x(encoder, value) {
        var tmp0_inlineEncoder = encoder.r14(this.d4x_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.n14(_Volume___get_cubicMeters__impl__6kaaeg(value));
        }
      }
      oz(encoder, value) {
        return this.e4x(encoder, value instanceof Volume() ? value.c4x_1 : THROW_CCE());
      }
      f4x(decoder) {
        return _Volume___init__impl__tjrqop(decoder.j13(this.d4x_1).f13());
      }
      pz(decoder) {
        return new (Volume())(this.f4x(decoder));
      }
      az() {
        return this.d4x_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
function Volume__hashCode_impl_6uhya0($this) {
  return getNumberHashCode($this);
}
function Volume__equals_impl_226xkc($this, other) {
  if (!(other instanceof Volume()))
    return false;
  var tmp0_other_with_cast = other.c4x_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var VolumeClass;
function Volume() {
  if (VolumeClass === VOID) {
    class $ {
      constructor(cubicMeters) {
        this.c4x_1 = cubicMeters;
      }
      g4x(other) {
        return Volume__compareTo_impl_e47i3d(this.c4x_1, other);
      }
      d(other) {
        return Volume__compareTo_impl_e47i3d_0(this, other);
      }
      toString() {
        return Volume__toString_impl_ewnyiv(this.c4x_1);
      }
      hashCode() {
        return Volume__hashCode_impl_6uhya0(this.c4x_1);
      }
      equals(other) {
        return Volume__equals_impl_226xkc(this.c4x_1, other);
      }
    }
    initMetadataForClass($, 'Volume', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_2});
    VolumeClass = $;
  }
  return VolumeClass;
}
function _Mass___init__impl__g55pzh(kilograms) {
  return kilograms;
}
function _Mass___get_kilograms__impl__lr3pd5($this) {
  return $this;
}
function Mass__compareTo_impl_3ilym9($this, other) {
  return compareTo(_Mass___get_kilograms__impl__lr3pd5($this), _Mass___get_kilograms__impl__lr3pd5(other));
}
function Mass__compareTo_impl_3ilym9_0($this, other) {
  return Mass__compareTo_impl_3ilym9($this.h4x_1, other instanceof Mass() ? other.h4x_1 : THROW_CCE());
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
function Mass__toString_impl_yxkxoz($this) {
  return '' + _Mass___get_kilograms__impl__lr3pd5($this) + ' kg';
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.Mass', this);
        tmp0_serialDesc.c1b('kilograms', false);
        this.i4x_1 = tmp0_serialDesc;
      }
      j4x(encoder, value) {
        var tmp0_inlineEncoder = encoder.r14(this.i4x_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.n14(_Mass___get_kilograms__impl__lr3pd5(value));
        }
      }
      oz(encoder, value) {
        return this.j4x(encoder, value instanceof Mass() ? value.h4x_1 : THROW_CCE());
      }
      k4x(decoder) {
        return _Mass___init__impl__g55pzh(decoder.j13(this.i4x_1).f13());
      }
      pz(decoder) {
        return new (Mass())(this.k4x(decoder));
      }
      az() {
        return this.i4x_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
function Mass__hashCode_impl_ecd7ha($this) {
  return getNumberHashCode($this);
}
function Mass__equals_impl_k5bdom($this, other) {
  if (!(other instanceof Mass()))
    return false;
  var tmp0_other_with_cast = other.h4x_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var MassClass;
function Mass() {
  if (MassClass === VOID) {
    class $ {
      constructor(kilograms) {
        this.h4x_1 = kilograms;
      }
      l4x(other) {
        return Mass__compareTo_impl_3ilym9(this.h4x_1, other);
      }
      d(other) {
        return Mass__compareTo_impl_3ilym9_0(this, other);
      }
      toString() {
        return Mass__toString_impl_yxkxoz(this.h4x_1);
      }
      hashCode() {
        return Mass__hashCode_impl_ecd7ha(this.h4x_1);
      }
      equals(other) {
        return Mass__equals_impl_k5bdom(this.h4x_1, other);
      }
    }
    initMetadataForClass($, 'Mass', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_3});
    MassClass = $;
  }
  return MassClass;
}
function _Speed___init__impl__580hla(metersPerSecond) {
  return metersPerSecond;
}
function _Speed___get_metersPerSecond__impl__t1zksw($this) {
  return $this;
}
function Speed__compareTo_impl_wpf88c($this, other) {
  return compareTo(_Speed___get_metersPerSecond__impl__t1zksw($this), _Speed___get_metersPerSecond__impl__t1zksw(other));
}
function Speed__compareTo_impl_wpf88c_0($this, other) {
  return Speed__compareTo_impl_wpf88c($this.m4x_1, other instanceof Speed() ? other.m4x_1 : THROW_CCE());
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_4();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
function Speed__toString_impl_c0l98a($this) {
  return '' + _Speed___get_metersPerSecond__impl__t1zksw($this) + ' m/s';
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.Speed', this);
        tmp0_serialDesc.c1b('metersPerSecond', false);
        this.n4x_1 = tmp0_serialDesc;
      }
      o4x(encoder, value) {
        var tmp0_inlineEncoder = encoder.r14(this.n4x_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.n14(_Speed___get_metersPerSecond__impl__t1zksw(value));
        }
      }
      oz(encoder, value) {
        return this.o4x(encoder, value instanceof Speed() ? value.m4x_1 : THROW_CCE());
      }
      p4x(decoder) {
        return _Speed___init__impl__580hla(decoder.j13(this.n4x_1).f13());
      }
      pz(decoder) {
        return new (Speed())(this.p4x(decoder));
      }
      az() {
        return this.n4x_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_4() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
function Speed__hashCode_impl_9qknkl($this) {
  return getNumberHashCode($this);
}
function Speed__equals_impl_ahn41l($this, other) {
  if (!(other instanceof Speed()))
    return false;
  var tmp0_other_with_cast = other.m4x_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var SpeedClass;
function Speed() {
  if (SpeedClass === VOID) {
    class $ {
      constructor(metersPerSecond) {
        this.m4x_1 = metersPerSecond;
      }
      q4x(other) {
        return Speed__compareTo_impl_wpf88c(this.m4x_1, other);
      }
      d(other) {
        return Speed__compareTo_impl_wpf88c_0(this, other);
      }
      toString() {
        return Speed__toString_impl_c0l98a(this.m4x_1);
      }
      hashCode() {
        return Speed__hashCode_impl_9qknkl(this.m4x_1);
      }
      equals(other) {
        return Speed__equals_impl_ahn41l(this.m4x_1, other);
      }
    }
    initMetadataForClass($, 'Speed', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_4});
    SpeedClass = $;
  }
  return SpeedClass;
}
function _Acceleration___init__impl__lpurpb(metersPerSecondPerSecond) {
  return metersPerSecondPerSecond;
}
function _Acceleration___get_metersPerSecondPerSecond__impl__3zde26($this) {
  return $this;
}
function Acceleration__compareTo_impl_v9l3hv($this, other) {
  return compareTo(_Acceleration___get_metersPerSecondPerSecond__impl__3zde26($this), _Acceleration___get_metersPerSecondPerSecond__impl__3zde26(other));
}
function Acceleration__compareTo_impl_v9l3hv_0($this, other) {
  return Acceleration__compareTo_impl_v9l3hv($this.r4x_1, other instanceof Acceleration() ? other.r4x_1 : THROW_CCE());
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_5();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
function Acceleration__toString_impl_8k4hwf($this) {
  return '' + _Acceleration___get_metersPerSecondPerSecond__impl__3zde26($this) + ' m/s\xB2';
}
var $serializerClass_5;
function $serializer_5() {
  if ($serializerClass_5 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_5 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.Acceleration', this);
        tmp0_serialDesc.c1b('metersPerSecondPerSecond', false);
        this.s4x_1 = tmp0_serialDesc;
      }
      t4x(encoder, value) {
        var tmp0_inlineEncoder = encoder.r14(this.s4x_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.n14(_Acceleration___get_metersPerSecondPerSecond__impl__3zde26(value));
        }
      }
      oz(encoder, value) {
        return this.t4x(encoder, value instanceof Acceleration() ? value.r4x_1 : THROW_CCE());
      }
      u4x(decoder) {
        return _Acceleration___init__impl__lpurpb(decoder.j13(this.s4x_1).f13());
      }
      pz(decoder) {
        return new (Acceleration())(this.u4x(decoder));
      }
      az() {
        return this.s4x_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_5 = $;
  }
  return $serializerClass_5;
}
var $serializer_instance_5;
function $serializer_getInstance_5() {
  if ($serializer_instance_5 === VOID)
    new ($serializer_5())();
  return $serializer_instance_5;
}
function Acceleration__hashCode_impl_ubaepa($this) {
  return getNumberHashCode($this);
}
function Acceleration__equals_impl_evel1u($this, other) {
  if (!(other instanceof Acceleration()))
    return false;
  var tmp0_other_with_cast = other.r4x_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var AccelerationClass;
function Acceleration() {
  if (AccelerationClass === VOID) {
    class $ {
      constructor(metersPerSecondPerSecond) {
        this.r4x_1 = metersPerSecondPerSecond;
      }
      v4x(other) {
        return Acceleration__compareTo_impl_v9l3hv(this.r4x_1, other);
      }
      d(other) {
        return Acceleration__compareTo_impl_v9l3hv_0(this, other);
      }
      toString() {
        return Acceleration__toString_impl_8k4hwf(this.r4x_1);
      }
      hashCode() {
        return Acceleration__hashCode_impl_ubaepa(this.r4x_1);
      }
      equals(other) {
        return Acceleration__equals_impl_evel1u(this.r4x_1, other);
      }
    }
    initMetadataForClass($, 'Acceleration', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_5});
    AccelerationClass = $;
  }
  return AccelerationClass;
}
function _Force___init__impl__w7900e(newtons) {
  return newtons;
}
function _Force___get_newtons__impl__qua8gd($this) {
  return $this;
}
function Force__compareTo_impl_fidpvc($this, other) {
  return compareTo(_Force___get_newtons__impl__qua8gd($this), _Force___get_newtons__impl__qua8gd(other));
}
function Force__compareTo_impl_fidpvc_0($this, other) {
  return Force__compareTo_impl_fidpvc($this.w4x_1, other instanceof Force() ? other.w4x_1 : THROW_CCE());
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_6();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
function Force__toString_impl_bms0tm($this) {
  return '' + _Force___get_newtons__impl__qua8gd($this) + ' N';
}
var $serializerClass_6;
function $serializer_6() {
  if ($serializerClass_6 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_6 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.Force', this);
        tmp0_serialDesc.c1b('newtons', false);
        this.x4x_1 = tmp0_serialDesc;
      }
      y4x(encoder, value) {
        var tmp0_inlineEncoder = encoder.r14(this.x4x_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.n14(_Force___get_newtons__impl__qua8gd(value));
        }
      }
      oz(encoder, value) {
        return this.y4x(encoder, value instanceof Force() ? value.w4x_1 : THROW_CCE());
      }
      z4x(decoder) {
        return _Force___init__impl__w7900e(decoder.j13(this.x4x_1).f13());
      }
      pz(decoder) {
        return new (Force())(this.z4x(decoder));
      }
      az() {
        return this.x4x_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_6 = $;
  }
  return $serializerClass_6;
}
var $serializer_instance_6;
function $serializer_getInstance_6() {
  if ($serializer_instance_6 === VOID)
    new ($serializer_6())();
  return $serializer_instance_6;
}
function Force__hashCode_impl_xdxxmh($this) {
  return getNumberHashCode($this);
}
function Force__equals_impl_di9dib($this, other) {
  if (!(other instanceof Force()))
    return false;
  var tmp0_other_with_cast = other.w4x_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var ForceClass;
function Force() {
  if (ForceClass === VOID) {
    class $ {
      constructor(newtons) {
        this.w4x_1 = newtons;
      }
      a4y(other) {
        return Force__compareTo_impl_fidpvc(this.w4x_1, other);
      }
      d(other) {
        return Force__compareTo_impl_fidpvc_0(this, other);
      }
      toString() {
        return Force__toString_impl_bms0tm(this.w4x_1);
      }
      hashCode() {
        return Force__hashCode_impl_xdxxmh(this.w4x_1);
      }
      equals(other) {
        return Force__equals_impl_di9dib(this.w4x_1, other);
      }
    }
    initMetadataForClass($, 'Force', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_6});
    ForceClass = $;
  }
  return ForceClass;
}
function _Pressure___init__impl__4rek04(pascals) {
  return pascals;
}
function _Pressure___get_pascals__impl__m59t3u($this) {
  return $this;
}
function Pressure__compareTo_impl_b1ld0u($this, other) {
  return compareTo(_Pressure___get_pascals__impl__m59t3u($this), _Pressure___get_pascals__impl__m59t3u(other));
}
function Pressure__compareTo_impl_b1ld0u_0($this, other) {
  return Pressure__compareTo_impl_b1ld0u($this.b4y_1, other instanceof Pressure() ? other.b4y_1 : THROW_CCE());
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_7();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_7;
function Companion_getInstance_7() {
  return Companion_instance_7;
}
function Pressure__toString_impl_a74mx0($this) {
  return '' + _Pressure___get_pascals__impl__m59t3u($this) + ' Pa';
}
var $serializerClass_7;
function $serializer_7() {
  if ($serializerClass_7 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_7 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.Pressure', this);
        tmp0_serialDesc.c1b('pascals', false);
        this.c4y_1 = tmp0_serialDesc;
      }
      d4y(encoder, value) {
        var tmp0_inlineEncoder = encoder.r14(this.c4y_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.n14(_Pressure___get_pascals__impl__m59t3u(value));
        }
      }
      oz(encoder, value) {
        return this.d4y(encoder, value instanceof Pressure() ? value.b4y_1 : THROW_CCE());
      }
      e4y(decoder) {
        return _Pressure___init__impl__4rek04(decoder.j13(this.c4y_1).f13());
      }
      pz(decoder) {
        return new (Pressure())(this.e4y(decoder));
      }
      az() {
        return this.c4y_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_7 = $;
  }
  return $serializerClass_7;
}
var $serializer_instance_7;
function $serializer_getInstance_7() {
  if ($serializer_instance_7 === VOID)
    new ($serializer_7())();
  return $serializer_instance_7;
}
function Pressure__hashCode_impl_vyajpv($this) {
  return getNumberHashCode($this);
}
function Pressure__equals_impl_9vxi6h($this, other) {
  if (!(other instanceof Pressure()))
    return false;
  var tmp0_other_with_cast = other.b4y_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var PressureClass;
function Pressure() {
  if (PressureClass === VOID) {
    class $ {
      constructor(pascals) {
        this.b4y_1 = pascals;
      }
      f4y(other) {
        return Pressure__compareTo_impl_b1ld0u(this.b4y_1, other);
      }
      d(other) {
        return Pressure__compareTo_impl_b1ld0u_0(this, other);
      }
      toString() {
        return Pressure__toString_impl_a74mx0(this.b4y_1);
      }
      hashCode() {
        return Pressure__hashCode_impl_vyajpv(this.b4y_1);
      }
      equals(other) {
        return Pressure__equals_impl_9vxi6h(this.b4y_1, other);
      }
    }
    initMetadataForClass($, 'Pressure', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_7});
    PressureClass = $;
  }
  return PressureClass;
}
function _Energy___init__impl__paow1l(joules) {
  return joules;
}
function _Energy___get_joules__impl__q784q($this) {
  return $this;
}
function Energy__compareTo_impl_gcljvv($this, other) {
  return compareTo(_Energy___get_joules__impl__q784q($this), _Energy___get_joules__impl__q784q(other));
}
function Energy__compareTo_impl_gcljvv_0($this, other) {
  return Energy__compareTo_impl_gcljvv($this.g4y_1, other instanceof Energy() ? other.g4y_1 : THROW_CCE());
}
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_8();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_8;
function Companion_getInstance_8() {
  return Companion_instance_8;
}
function Energy__toString_impl_jf1pax($this) {
  return '' + _Energy___get_joules__impl__q784q($this) + ' J';
}
var $serializerClass_8;
function $serializer_8() {
  if ($serializerClass_8 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_8 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.Energy', this);
        tmp0_serialDesc.c1b('joules', false);
        this.h4y_1 = tmp0_serialDesc;
      }
      i4y(encoder, value) {
        var tmp0_inlineEncoder = encoder.r14(this.h4y_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.n14(_Energy___get_joules__impl__q784q(value));
        }
      }
      oz(encoder, value) {
        return this.i4y(encoder, value instanceof Energy() ? value.g4y_1 : THROW_CCE());
      }
      j4y(decoder) {
        return _Energy___init__impl__paow1l(decoder.j13(this.h4y_1).f13());
      }
      pz(decoder) {
        return new (Energy())(this.j4y(decoder));
      }
      az() {
        return this.h4y_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_8 = $;
  }
  return $serializerClass_8;
}
var $serializer_instance_8;
function $serializer_getInstance_8() {
  if ($serializer_instance_8 === VOID)
    new ($serializer_8())();
  return $serializer_instance_8;
}
function Energy__hashCode_impl_2c47hy($this) {
  return getNumberHashCode($this);
}
function Energy__equals_impl_gsi3fq($this, other) {
  if (!(other instanceof Energy()))
    return false;
  var tmp0_other_with_cast = other.g4y_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var EnergyClass;
function Energy() {
  if (EnergyClass === VOID) {
    class $ {
      constructor(joules) {
        this.g4y_1 = joules;
      }
      k4y(other) {
        return Energy__compareTo_impl_gcljvv(this.g4y_1, other);
      }
      d(other) {
        return Energy__compareTo_impl_gcljvv_0(this, other);
      }
      toString() {
        return Energy__toString_impl_jf1pax(this.g4y_1);
      }
      hashCode() {
        return Energy__hashCode_impl_2c47hy(this.g4y_1);
      }
      equals(other) {
        return Energy__equals_impl_gsi3fq(this.g4y_1, other);
      }
    }
    initMetadataForClass($, 'Energy', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_8});
    EnergyClass = $;
  }
  return EnergyClass;
}
function _Power___init__impl__y6lnpo(watts) {
  return watts;
}
function _Power___get_watts__impl__8v3onk($this) {
  return $this;
}
function Power__compareTo_impl_pinqky($this, other) {
  return compareTo(_Power___get_watts__impl__8v3onk($this), _Power___get_watts__impl__8v3onk(other));
}
function Power__compareTo_impl_pinqky_0($this, other) {
  return Power__compareTo_impl_pinqky($this.l4y_1, other instanceof Power() ? other.l4y_1 : THROW_CCE());
}
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_9();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
function Power__toString_impl_dln6o4($this) {
  return '' + _Power___get_watts__impl__8v3onk($this) + ' W';
}
var $serializerClass_9;
function $serializer_9() {
  if ($serializerClass_9 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_9 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.Power', this);
        tmp0_serialDesc.c1b('watts', false);
        this.m4y_1 = tmp0_serialDesc;
      }
      n4y(encoder, value) {
        var tmp0_inlineEncoder = encoder.r14(this.m4y_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.n14(_Power___get_watts__impl__8v3onk(value));
        }
      }
      oz(encoder, value) {
        return this.n4y(encoder, value instanceof Power() ? value.l4y_1 : THROW_CCE());
      }
      o4y(decoder) {
        return _Power___init__impl__y6lnpo(decoder.j13(this.m4y_1).f13());
      }
      pz(decoder) {
        return new (Power())(this.o4y(decoder));
      }
      az() {
        return this.m4y_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_9 = $;
  }
  return $serializerClass_9;
}
var $serializer_instance_9;
function $serializer_getInstance_9() {
  if ($serializer_instance_9 === VOID)
    new ($serializer_9())();
  return $serializer_instance_9;
}
function Power__hashCode_impl_zct3gz($this) {
  return getNumberHashCode($this);
}
function Power__equals_impl_vorjd5($this, other) {
  if (!(other instanceof Power()))
    return false;
  var tmp0_other_with_cast = other.l4y_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var PowerClass;
function Power() {
  if (PowerClass === VOID) {
    class $ {
      constructor(watts) {
        this.l4y_1 = watts;
      }
      p4y(other) {
        return Power__compareTo_impl_pinqky(this.l4y_1, other);
      }
      d(other) {
        return Power__compareTo_impl_pinqky_0(this, other);
      }
      toString() {
        return Power__toString_impl_dln6o4(this.l4y_1);
      }
      hashCode() {
        return Power__hashCode_impl_zct3gz(this.l4y_1);
      }
      equals(other) {
        return Power__equals_impl_vorjd5(this.l4y_1, other);
      }
    }
    initMetadataForClass($, 'Power', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_9});
    PowerClass = $;
  }
  return PowerClass;
}
function _RelativeTemperature___init__impl__s2670v(celsius) {
  return celsius;
}
function _RelativeTemperature___get_celsius__impl__beofh4($this) {
  return $this;
}
function RelativeTemperature__compareTo_impl_e2gjaj($this, other) {
  return compareTo(_RelativeTemperature___get_celsius__impl__beofh4($this), _Temperature___get_celsius__impl__lhbsrw(other));
}
function RelativeTemperature__compareTo_impl_e2gjaj_0($this, other) {
  return RelativeTemperature__compareTo_impl_e2gjaj($this.q4y_1, other instanceof Temperature() ? other.q4w_1 : THROW_CCE());
}
var CompanionClass_10;
function Companion_10() {
  if (CompanionClass_10 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_10();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_10 = $;
  }
  return CompanionClass_10;
}
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
function RelativeTemperature__toString_impl_14ouzr($this) {
  return '' + _RelativeTemperature___get_celsius__impl__beofh4($this) + '\xB0C';
}
var $serializerClass_10;
function $serializer_10() {
  if ($serializerClass_10 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_10 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('com.lightningkite.RelativeTemperature', this);
        tmp0_serialDesc.c1b('celsius', false);
        this.r4y_1 = tmp0_serialDesc;
      }
      s4y(encoder, value) {
        var tmp0_inlineEncoder = encoder.r14(this.r4y_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.n14(_RelativeTemperature___get_celsius__impl__beofh4(value));
        }
      }
      oz(encoder, value) {
        return this.s4y(encoder, value instanceof RelativeTemperature() ? value.q4y_1 : THROW_CCE());
      }
      t4y(decoder) {
        return _RelativeTemperature___init__impl__s2670v(decoder.j13(this.r4y_1).f13());
      }
      pz(decoder) {
        return new (RelativeTemperature())(this.t4y(decoder));
      }
      az() {
        return this.r4y_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_10 = $;
  }
  return $serializerClass_10;
}
var $serializer_instance_10;
function $serializer_getInstance_10() {
  if ($serializer_instance_10 === VOID)
    new ($serializer_10())();
  return $serializer_instance_10;
}
function RelativeTemperature__hashCode_impl_mvursm($this) {
  return getNumberHashCode($this);
}
function RelativeTemperature__equals_impl_ugknyy($this, other) {
  if (!(other instanceof RelativeTemperature()))
    return false;
  var tmp0_other_with_cast = other.q4y_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var RelativeTemperatureClass;
function RelativeTemperature() {
  if (RelativeTemperatureClass === VOID) {
    class $ {
      constructor(celsius) {
        this.q4y_1 = celsius;
      }
      w4w(other) {
        return RelativeTemperature__compareTo_impl_e2gjaj(this.q4y_1, other);
      }
      d(other) {
        return RelativeTemperature__compareTo_impl_e2gjaj_0(this, other);
      }
      toString() {
        return RelativeTemperature__toString_impl_14ouzr(this.q4y_1);
      }
      hashCode() {
        return RelativeTemperature__hashCode_impl_mvursm(this.q4y_1);
      }
      equals(other) {
        return RelativeTemperature__equals_impl_ugknyy(this.q4y_1, other);
      }
    }
    initMetadataForClass($, 'RelativeTemperature', VOID, VOID, [Comparable()], VOID, VOID, {0: $serializer_getInstance_10});
    RelativeTemperatureClass = $;
  }
  return RelativeTemperatureClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
Companion_instance_2 = new (Companion_2())();
Companion_instance_3 = new (Companion_3())();
Companion_instance_4 = new (Companion_4())();
Companion_instance_5 = new (Companion_5())();
Companion_instance_6 = new (Companion_6())();
Companion_instance_7 = new (Companion_7())();
Companion_instance_8 = new (Companion_8())();
Companion_instance_9 = new (Companion_9())();
Companion_instance_10 = new (Companion_10())();
//endregion
//region block: exports
export {
  Temperature as Temperature20f98n8g5dacx,
  _Length___get_kilometers__impl__syiikt as _Length___get_kilometers__impl__syiikt2f7wyh2ltp7k3,
  _Temperature___get_celsius__impl__lhbsrw as _Temperature___get_celsius__impl__lhbsrw20893twwx7n3g,
  _Temperature___get_fahrenheit__impl__xao1tu as _Temperature___get_fahrenheit__impl__xao1tu3k07fe8wpsxj7,
  Companion_instance_5 as Companion_instance2sdho14d7q7c5,
  Companion_instance_1 as Companion_instancexvm2tzznrout,
  Companion_instance_8 as Companion_instancen5s0hxc4knyr,
  Companion_instance_6 as Companion_instance3guk37so2mnmx,
  Companion_instance as Companion_instance3nlomj2jjs1fp,
  Companion_instance_3 as Companion_instance2aphy0qwzrjp9,
  Companion_instance_9 as Companion_instance384swmewitwnw,
  Companion_instance_7 as Companion_instance2bdpnlo55frwb,
  Companion_instance_10 as Companion_instance1l92zutxh2ysq,
  Companion_instance_4 as Companion_instance3heqqn8gfw4dg,
  Companion_instance_0 as Companion_instance17glu83oz0rte,
  Companion_instance_2 as Companion_instance1olveu2h2p0bp,
};
//endregion

//# sourceMappingURL=usefulTypes.mjs.map
